export { default } from './InfoCardCarousel';
